import $ from 'jquery';
import _ from 'lodash';
import { greenImageSize } from './constants';
import { addClassSvg } from './helpers';
import { distanceCalc } from './visageHelpers';
import { store } from '../../../redux/store';

export const createBoundary = (hole, svg, hideGrid) => {
    
    let left, width, top, height;

    // FB 2886: Use X Y values for grids when data from manifest and lat / long when new data site.
    function createXYwhenNotAvailable(pt) {
       if (pt.X === 0 && pt.Y === 0) {
          var tmp = hole.worldToImage.transformPoint(pt.Longitude, pt.Latitude);
          pt.X = tmp[0];
          pt.Y = tmp[1];
       }
    };

    try {
       let ptLOG = _.filter(hole.PoiData, { 'Name': 'LeftOfGreen' })[0];
       let copyOfptLOG = {...ptLOG}
       createXYwhenNotAvailable(copyOfptLOG);
       left = hole.viewToGreen.transformPoint(copyOfptLOG.X, copyOfptLOG.Y)[0];

       let ptROG = _.filter(hole.PoiData, { 'Name': 'RightOfGreen' })[0];
       let copyOfptROG = {...ptROG}
       createXYwhenNotAvailable(copyOfptROG);
       width = hole.viewToGreen.transformPoint(copyOfptROG.X, copyOfptROG.Y)[0] - left;

       let ptBOG = _.filter(hole.PoiData, { 'Name': 'BackOfGreen1' })[0];
       let copyOfptBOG = { ...ptBOG }
       createXYwhenNotAvailable(copyOfptBOG);
       top = hole.viewToGreen.transformPoint(copyOfptBOG.X, copyOfptBOG.Y)[1];

       let ptFOG = _.filter(hole.PoiData, { 'Name': 'FrontOfGreen' })[0];
       let copyOfptFOG = { ...ptFOG }
       createXYwhenNotAvailable(copyOfptFOG);
       height = hole.viewToGreen.transformPoint(copyOfptFOG.X, copyOfptFOG.Y)[1] - top;
    } catch (e) {
       // If the boundary is unavailable, set at outside of grid.
       left = 0;
       width = greenImageSize;
       top = 0;
       height = greenImageSize;
    }

    hole.left = left;
    hole.right = left + width;
    hole.back = top;
    hole.front = top + height;

    var loc = hole.greenToWorld.transformPoint(left, top);
    hole.greenBoxUL = { lng: loc[0], lat: loc[1] };

    loc = hole.greenToWorld.transformPoint(hole.right, top);
    hole.greenBoxUR = { lng: loc[0], lat: loc[1] };

    loc = hole.greenToWorld.transformPoint(hole.right, hole.front);
    hole.greenBoxLR = { lng: loc[0], lat: loc[1] };
    
    loc = hole.greenToWorld.transformPoint(left, hole.front);
    hole.greenBoxLL = { lng: loc[0], lat: loc[1] };


    // Provide depth and width information as computed so that yards/meters change calculate automatically.
    const widthData = () => {
        let state = store.getState();
        let viewDistanceYards = state.firstReducer.viewDistanceYardsReduxState
        let width = Math.round(distanceCalc.distanceBetweenPoints(hole.greenBoxUL, hole.greenBoxUR, viewDistanceYards));
        let units = viewDistanceYards ? 'yds' : 'm';
        $('#holeWidth_' + hole.Hole).html(width + units);
        return (width + units);
    }
    
    hole.holeWidth = widthData()

    const depthData = () => {
         let state = store.getState();
         let viewDistanceYards = state.firstReducer.viewDistanceYardsReduxState
         let depth = Math.round(distanceCalc.distanceBetweenPoints(hole.greenBoxUL, hole.greenBoxLL, viewDistanceYards));
         let units = viewDistanceYards ? 'yds' : 'm';
        $('#holeDepth_' + hole.Hole).html(depth + units);
        return (depth + units);
    }

    hole.holeDepth = depthData()

    // Create grid if size is positive.
    if (width > 0 && height > 0) {
       createBoundaryRect({ width: width, height: height, x: left, y: top });
       createBoundaryRect({
          width: width, height: Math.floor(height / 3), x: left, y: Math.floor(height / 3) + top
       });
       createBoundaryRect({
          width: Math.floor(width / 3), height: height, x: Math.floor(width / 3) + left, y: top
       });
    }

    // TODO -- Create adjustment for green size if privileges allow -- Dependent on User Roles / Admin Roles
    // if (datacontext.canAccessSiteSetup()) {
    //    var createSelector = function (x, y, error) {
    //       var selectorFormat = { 'fill-opacity': '0.0', 'stroke-width': '2' };
    //       var selector = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    //       setAttributes(selector, $.extend({}, selectorFormat,
    //          { cx: x, cy: y, r: 6, 'class': 'greenSelector', 'stroke': (error) ? 'red' : 'blue' }));
    //       if (!editGreens()) addClassSvg(selector, 'hide');
    //       svg.appendChild(selector);
    //    };

    //    // Determine if the green selection markers are not representing UL and LR.
    //    var error = ((left < (left + width)) && (top > (top + height))) || ((left > (left + width)) && (top < (top + height)));
    //    createSelector(left, top, error);
    //    createSelector(left + width, top + height, error);
    // }

    // Create the object

    function setAttributes(el, attrs) {
        for (var key in attrs) {
           el.setAttributeNS(null, key, attrs[key]);
        }
     }

    function createBoundaryRect(size) {
       let state = store.getState();
       let viewGrid = state.firstReducer.viewGridsReduxState
       let boundaryFormat = { 'fill-opacity': '0.0', 'stroke-width': '1', 'stroke': 'grey', };
       let boundary = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
       addClassSvg(boundary, 'greenBoundary'); 
       if (!viewGrid || hideGrid) addClassSvg(boundary, 'hide');
       let format = $.extend({}, boundaryFormat,
          { 'width': size.width, 'height': size.height, 'x': size.x, 'y': size.y });
       setAttributes(boundary, format);

       svg.appendChild(boundary);
    }
 }